export default __webpack_public_path__ + "static/media/ican.5164bf35.png";